module.exports = ol.layer.Vector;